import { Entity } from '@backstage/catalog-model';

import {
  DetectedFramework,
  FrameworkId,
  readFrameworkLabels,
} from '@internal/backstage-plugin-framework-versions-common';

export const FRAMEWORKS: Record<FrameworkId, { title: string }> = {
  dotnet: { title: '.NET' },
  dotnetfx: { title: '.NET Framework' },
  angular: { title: 'Angular' },
  react: { title: 'React' },
  nodejs: { title: 'Node.js' },
  java: { title: 'Java' },
  'spring-boot': { title: 'Spring Boot' },
};

export const readFrameworks = (entity: Entity): DetectedFramework[] =>
  readFrameworkLabels(entity.metadata.labels);
